"use client";
import { ButtonProps } from "../Button/types";
import { LinkProps } from "next/dist/client/link";
import { Button, ButtonLink } from "../Button";
import { MakePropertyOptional, onEventScrollTo } from "@itchannelplus/utils";

export interface ScrollToButtonProps extends ButtonProps {
  scrollTo?: string;
}

export const ScrollToButton = ({ scrollTo, ...props }: ScrollToButtonProps) => {
  return <Button onClick={scrollTo && onEventScrollTo(scrollTo)} {...props} />;
};

export const ScrollToButtonLink = ({
  scrollTo,
  ...props
}: ScrollToButtonProps & MakePropertyOptional<LinkProps, "href">) => {
  return (
    <ButtonLink
      onClick={scrollTo && onEventScrollTo(scrollTo)}
      {...props}
      href={props.href ? props.href + "#" + scrollTo : '#' + scrollTo }
    />
  );
};
